// exports all custom classes globally

/**
 * @author -- Peter Collins /github.com/chimdipetercollins
 */

import Contact from './contact'
import Equipment from './equipment'
import Location from './location'
import User from './user'
import Username from './username'
import Property from './property'
import Vehicle from './vehicle'

export default {
    install (Vue) {
        Vue.prototype.$classes = {
            contact: new Contact(),
            equipment: new Equipment(),
            location: new Location(),
            property: new Property(),
            user: new User(),
            username: new Username(),
            vehicle: new Vehicle()
        }
    }
}
